var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-display", {
        class:
          _vm.compararImovel && _vm.compararImovel.mudouPossuiCar ? "text" : "",
        attrs: {
          label: "Possui CAR?",
          content: _vm.imovel.possuiCar ? "Sim" : "Não"
        }
      }),
      _vm.imovel.numeroReciboCar
        ? _c("app-display", {
            class:
              _vm.compararImovel && _vm.compararImovel.mudouNumeroReciboCar
                ? "text"
                : "",
            attrs: {
              label: "Número do recibo:",
              content: _vm.imovel.numeroReciboCar,
              marginBottom: true
            }
          })
        : _vm._e(),
      _vm.imovel.nome
        ? _c("app-display", {
            class:
              _vm.compararImovel && _vm.compararImovel.mudouNome ? "text" : "",
            attrs: { label: "Nome do Imóvel:", content: _vm.imovel.nome }
          })
        : _vm._e(),
      _vm.imovel.municipio
        ? _c("app-display", {
            class:
              _vm.compararImovel && _vm.compararImovel.mudouMunicipio
                ? "text"
                : "",
            attrs: { label: "Município:", content: _vm.imovel.municipio.nome }
          })
        : _vm._e(),
      _vm.imovel.formattedValueArea
        ? _c("app-display", {
            class:
              _vm.compararImovel && _vm.compararImovel.mudouArea ? "text" : "",
            attrs: { label: "Área:", content: _vm.imovel.formattedValueArea }
          })
        : _vm._e(),
      _vm.imovel.formattedValueFinalidades
        ? _c("app-display", {
            class:
              _vm.compararImovel && _vm.compararImovel.mudouFinalidadesImovel
                ? "text"
                : "",
            attrs: {
              label: "Finalidades:",
              content: _vm.imovel.formattedValueFinalidades
            }
          })
        : _vm._e(),
      _vm.imovel.descricaoAcesso
        ? _c("app-display", {
            class:
              _vm.compararImovel && _vm.compararImovel.mudouDescricaoAcesso
                ? "text"
                : "",
            attrs: {
              label: "Descrição de acesso:",
              content: _vm.imovel.descricaoAcesso
            }
          })
        : _vm._e(),
      _vm.imovel.ocupantesAnteriores !== null && !_vm.imovel.possuiCar
        ? _c(
            "div",
            [
              _vm.imovel.ocupantesAnteriores !== null
                ? _c("app-display", {
                    class:
                      _vm.compararImovel &&
                      _vm.compararImovel.mudouOcupantesAnteriores
                        ? "text"
                        : "",
                    attrs: {
                      label: "Há ocupantes anteriores?",
                      content: _vm.imovel.ocupantesAnteriores ? "Sim" : "Não"
                    }
                  })
                : _vm._e(),
              _vm.imovel.possuiImovel != null
                ? _c("app-display", {
                    class:
                      _vm.compararImovel && _vm.compararImovel.mudouPossuiImovel
                        ? "text"
                        : "",
                    attrs: {
                      label:
                        "Possui outros imóveis rurais no " + _vm.ESTADO + "?",
                      content: _vm.imovel.possuiImovel ? "Sim" : "Não"
                    }
                  })
                : _vm._e(),
              _vm.imovel.conflitos != null
                ? _c("app-display", {
                    class:
                      _vm.compararImovel && _vm.compararImovel.mudouConflitos
                        ? "text"
                        : "",
                    attrs: {
                      label: "Há conflitos no imóvel?",
                      content: _vm.imovel.conflitos ? "Sim" : "Não"
                    }
                  })
                : _vm._e(),
              _vm.imovel.numeroProcessoJudicial
                ? _c("app-display", {
                    class:
                      _vm.compararImovel &&
                      _vm.compararImovel.mudouNumeroProcessoJudicial
                        ? "text"
                        : "",
                    attrs: {
                      label: "Número do processo judicial:",
                      content: _vm.imovel.numeroProcessoJudicial
                    }
                  })
                : _vm._e(),
              _vm.imovel.nomeTempoOcupacao !== null
                ? _c("app-display", {
                    attrs: {
                      label: "Tempo de ocupação:",
                      content: _vm.imovel.nomeTempoOcupacao
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73c44dfe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73c44dfe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/cadastrosOnline/InformacoesImovel.vue
// module id = null
// module chunks = 